module.exports = __webpack_public_path__ + "static/media/POPs.aa8883fb.webp";